// src/pages/Documents_files_new.jsx
import React, { useState } from "react";
import { Table, Badge } from "react-bootstrap";
import { getFileIcon } from "../../utils/fileIcon";
import { folderIcon, trashIcon } from "../../utils/icons";
import PreviewFileModal from "../../components/common/Filemanager_PreviewFileModal";
import { downloadFile } from "../../utils/downloadFiles";
import { setLoading } from "../../feature/loading.slice";
import { setMessage } from "../../feature/message.slice";
import messages from "../../utils/meesage";
import { useDispatch } from "react-redux";
// import FilesServiceNew from "../../services/filesNew.service";
import FilesService from "../../services/files.service";

const Documents_files_new = ({ responseData, getFiles,onFolderClick  }) => {
  const [show, setShow] = useState(false);
  const [fileBlob, setFileBlob] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [approved, setApproved] = useState(false);
  const [approvedShow, setApprovedShow] = useState(false);
  const [FileId, setFileId] = useState("");

  const dispatch = useDispatch();

  const handleShow = async (file) => {
    try {
      dispatch(setLoading(true));
      dispatch(setMessage(messages.loading));
      const res = await FilesService.filePreview(file.id);
      if (res) {
        const blob = res.data;
        const blobUrl = URL.createObjectURL(blob);
        setFileBlob(blobUrl);
        setFileType(res.headers["content-type"]);
        // Use file extension from file_name
        const ext = file.file_name.split(".").pop().toLowerCase();


        const previewExtensions = ["pdf", "png", "jpg", "jpeg"];


         if (previewExtensions.includes(ext)) {
        // Open preview modal
        setShow(true);
      } else {
        // Direct download for all other types
        downloadFile(blobUrl, file.file_name);
      }


     
      } else {
        console.error("Failed to fetch file");
      }
    } catch (err) {
      setFileBlob(null);
      setShow(true);
      dispatch(setLoading(false));
      console.log(err);
    }
  };

  const uploadViewhandleShow = async (file) => {
    dispatch(setLoading(true));
    dispatch(setMessage(messages.loading));
    if (file.approval_status === "approved" || file.approval_status === "rejected") {
      setApproved(false);
    } else {
      setApproved(true);
    }
    setFileId(file.id);
    setApprovedShow(true);
    setShow(true);
    const res = await FilesService.filePreview(file.id);
    if (res) {
      const blob = res.data;
      const blobUrl = URL.createObjectURL(blob);
      setFileBlob(blobUrl);
      setFileType(res.headers["content-type"]);
      dispatch(setLoading(false));
    }
  };

  const handleDelete = async (id) => {
    try {
      dispatch(setLoading(true));
      dispatch(setMessage(messages.loading));
      await FilesService.DeleteFile(id);
      getFiles(); // refresh after deletion
      dispatch(setMessage(messages.success.FILE_DELETE));
    } catch (err) {
      console.log(err);
    } finally {
      setTimeout(() => {
        dispatch(setLoading(false));
      }, 3000);
    }
  };

  const ucfirst = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

  return (
    <div className="documents_files">
      <div className="table-responsive">
        <Table hover responsive>
          <thead>
            <tr>
              <th>Name</th>
              {/* <th>Type</th> */}
              <th>Company Name</th>
              <th>Created By</th>
              <th>Created On</th>
              <th>Status</th>
              {/* Optionally, you may add a Trash/Delete column */}
            </tr>
          </thead>
          <tbody>
            {/* Render Folders */}
            {responseData.folders &&
              responseData.folders.map((folder) => (
                <tr key={`folder-${folder.id}`}>
                  <td  onClick={() => {
                      if (onFolderClick) {
                        onFolderClick(folder);
                      } else {
                        getFiles(folder.id);
                      }
                    }}>
                    <div className="d-flex align-items-center">
                      <span className="icon">
                        <img
                          src={folderIcon}
                          className="file-icon me-2"
                          alt="Folder"
                        />
                      </span>
                      <span role="button">{folder.folder_name}</span>
                    </div>
                  </td>
                  <td>{folder.client_name || "-"}</td>
                  {/* <td>Folder</td> */}
                  <td>{folder.created_by_name || "-"}</td>
                  <td>{folder.created_at || "-"}</td>
                  <td>-</td>
                </tr>
              ))}

            {/* Render Files */}
            {responseData.files &&
              responseData.files.map((file) => (
                <tr key={`file-${file.id}`}>
                  <td>
                    <div className="d-flex align-items-center">
                      <span className="icon">
                        <img
                          src={getFileIcon(file.file_name.split(".").pop())}
                          className="file-icon me-2"
                          alt="File"
                        />
                      </span>
                      <span role="button" onClick={() => handleShow(file)}>
                        {file.file_name}
                      </span>
                    </div>
                  </td>
                  <td>{file.client_name || "-"}</td>
                  {/* <td>File</td> */}
                  <td>{file.uploaded_by_name || "-"}</td>
                  <td>{file.created_at || "-"}</td>
                  <td>
                    {file.approval_status === "pending" ? (
                      <Badge pill bg="dark" onClick={() => uploadViewhandleShow(file)}>
                        View & Approve
                      </Badge>
                    ) : (
                      <span
                        className={`badge rounded-pill ${
                          file.approval_status.toLowerCase() === "approved"
                            ? "bg-success"
                            : "bg-secondary"
                        }`}
                      >
                        {ucfirst(file.approval_status)}
                      </span>
                    )}
                  </td>
                  <td className="text-center">
                    {file.action && (
                      <div>
                        <img
                          role="button"
                          src={trashIcon}
                          alt="Trash"
                          onClick={() => handleDelete(file.id)}
                        />
                      </div>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
        {/* Add pagination if needed */}
      </div>
      {show &&  (
        <PreviewFileModal
          show={show}
          handleClose={() => setShow(false)}
          fileUrl={fileBlob}
          fileType={fileType}
          approved={approved}
          approvedShow={approvedShow}
          handleapprovedFile={() => {}}
        />
      )}
    </div>
  );
};

export default Documents_files_new;
